<template>
  <el-card>
    <el-row class="recommended__title"> 用户推荐列表规则配置 </el-row>
    <!-- 搜索 -->
    <el-row class="recommended__search">
      <span>规则名称：</span>
      <el-input v-model="search.ruleName" placeholder="请输入" style="width: 200px"></el-input>
      <span>状态：</span>
      <el-select v-model="search.valid" style="width: 100px" placeholder="请选择" clearable>
        <el-option label="全部" :value="null"> </el-option>
        <el-option label="下线" :value="0"> </el-option>
        <el-option label="上线" :value="1"> </el-option>
      </el-select>
      <span>渠道：</span>
      <el-select v-model="search.channel" clearable filterable placeholder="请选择">
        <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <span>列表码：</span>
      <el-select v-model="search.listCode" placeholder="请选择" clearable filterable style="width: 150px">
        <el-option v-for="(item, index) in codeList" :key="index" :label="item.title" :value="item.code"></el-option>
      </el-select>
      <span>标签名称：</span>
      <el-select v-model="search.userSign" placeholder="请选择" clearable filterable style="width: 200px">
        <el-option v-for="(item, index) in hostSignlist" :key="index" :label="item.name" :value="item.name"></el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="primary" @click="getList(1)">查询</el-button>
      <el-button style="margin-top: 10px" type="primary" @click="
        () => {
          dialogType = 0
          dialogShow = true
          isEditMode = false
        }
      ">新增</el-button>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="ruleName" label="规则名字" align="center">
        </el-table-column>
        <el-table-column prop="listCodeName" label="列表类型" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.channel && scope.row.channel.startsWith('-')" style="color: red;">排除: </span>
              <span>{{ scope.row.channel ? scope.row.channel.replace(/^-/, '') : '' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userSign" label="主播标签" align="center"></el-table-column>
        <el-table-column prop="refreshInterval" label="刷新间隔/秒" align="center">
          <template slot-scope="scope">
            {{
              scope.row.refreshInterval < 60 ? `${scope.row.refreshInterval}秒` : `${(scope.row.refreshInterval /
                60).toFixed(2)}分钟` }} </template>
        </el-table-column>
        <el-table-column prop="pageSize" label="每页推荐人数" align="center"></el-table-column>
        <el-table-column prop="pageMax" label="最大页数" align="center"></el-table-column>
        <el-table-column prop="userConfigList" label="被推荐用户" align="center" width="200">
          <template slot-scope="scope">
            <div class="list">
              <div class="mode" v-for="(item, index) in scope.row.userConfigList" :key="index">
                <p>
                  被推荐用户类型：<i>{{ item.userSign }}</i>
                </p>
                <p>推荐人数：{{ item.userNums }}</p>
                <p>优先级：{{ item.priorityLevel }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="refreshInterval" label="用户隐藏规则" align="center" width="200">
          <template slot-scope="scope">
            <div class="con">
              当用户<i>{{ scope.row.pushLimitSeconds / 60 }}</i>分钟内被推送<i>{{ scope.row.pushLimitCount }}</i>次时，隐藏时间<i>{{
                scope.row.hideTimeMinSeconds }}-{{
                  scope.row.hideTimeMaxSeconds
                }}</i>秒之间随机数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="listCode" label="列表类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid === 0 ? '下线' : '上线' }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="copy(scope.row.id)">复制</el-button>
            <el-button type="text" @click="deletes(scope.row.id)">删除</el-button>
            <el-button type="text" @click="changeValid(scope.row)">{{
              scope.row.valid === 1 ? '下线' : '上线'
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination background layout="prev, pager, next" :page-count="this.totalPages"
        @current-change="guaranteedHandleCurrentChange">
      </el-pagination>
    </el-row>
    <el-dialog :title="dialogType == 0 ? '新增' : '编辑'" :visible.sync="dialogShow" width="60%"
      :before-close="handleClose">
      <el-form :rules="rules" ref="formData" :model="formData" label-width="120px">
        <el-form-item label="类型" label-width="120px">
          <el-select v-model="dialogInfoType" style="width: 100px" placeholder="请选择" clearable>
            <el-option label="主播" :value="0"> </el-option>
            <el-option label="用户" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道" label-width="120px">
          <div>
            <el-checkbox v-model="excludeChannel" style="margin-bottom: 10px;"
              @change="handleChannelChange">排除渠道</el-checkbox>
            <el-select v-model="selectedChannels" collapse-tags multiple clearable filterable placeholder="请选择渠道"
              @change="handleChannelChange">
              <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="规则名字" label-width="120px" prop="ruleName">
          <el-input v-model.trim="formData.ruleName" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="列表类型" label-width="120px" prop="listCode">
          <!-- <el-select
            v-model="formData.listCode"
            placeholder="请选择"
            clearable
            filterable
            style="width: 150px"
          >
            <el-option
              v-for="(item, index) in codeList"
              :key="index"
              :label="item.title"
              :value="item.code"
            >
              <span style="float: left">{{ item.title }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.code
              }}</span>
            </el-option>
          </el-select> -->
          <el-cascader v-model="formData.listCode" clearable :options="formatterJumpData(codeList)"
            :props="{ emitPath: false }"></el-cascader>
        </el-form-item>
        <el-form-item :label="dialogInfoType == 0 ? '主播标签' : '用户标签'" label-width="120px" prop="userSign">
          <!-- <el-select v-model="formData.userSign" placeholder="请选择" clearable filterable style="width: 200px">
            <el-option v-for="(item, index) in dialogInfoType == 0
              ? hostSignlist
              : userSignlist" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select> -->
          <el-cascader v-model="formData.userSign" clearable :props="propsForFormData" :options="currentOptions"
            :key="cascaderKey" change-on-select v-cascaderScroll="loadMoreSignData"></el-cascader>
        </el-form-item>
        <el-form-item label="推送次数" label-width="120px">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span>下限：</span>
            <el-form-item prop="pushTimesMin" style="margin-bottom: 0;">
              <el-input-number v-model.trim="formData.pushTimesMin" :step="1" :step-strictly="true" :min="0"
                style="width: 120px;" @change="validatePushTimes"></el-input-number>
            </el-form-item>
            <span>上限：</span>
            <el-form-item prop="pushTimesMax" style="margin-bottom: 0;">
              <el-input-number v-model.trim="formData.pushTimesMax" :step="1" :step-strictly="true" :min="0"
                style="width: 120px;" @change="validatePushTimes"></el-input-number>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="刷新间隔/秒" label-width="120px" prop="refreshInterval">
          <el-input-number v-model.trim="formData.refreshInterval" :step="1" :step-strictly="true"></el-input-number>
        </el-form-item>
        <el-form-item label="每页推荐人数" label-width="120px" prop="pageSize">
          <el-input-number v-model.trim="formData.pageSize" :step="1" :step-strictly="true"></el-input-number>
        </el-form-item>
        <el-form-item label="最大页数" label-width="120px" prop="pageMax">
          <el-input-number v-model.trim="formData.pageMax" :step="1" :step-strictly="true"></el-input-number>
        </el-form-item>
        <el-form-item label="用户隐藏规则" label-width="120px">
          <!-- prop="pushLimitSeconds" -->
          <div>
            当用户<el-input-number v-model.trim="minute" :precision="1" :min="1" @change="
              (val) => {
                formData.pushLimitSeconds = minute * 60
              }
            "></el-input-number>
            分钟内被推送<el-input-number v-model.trim="formData.pushLimitCount" :step="1" :step-strictly="true"
              :min="1"></el-input-number>次，隐藏时间<el-input-number v-model.trim="formData.hideTimeMinSeconds" :step="1"
              :step-strictly="true" :min="1"></el-input-number>秒至<el-input-number
              v-model.trim="formData.hideTimeMaxSeconds" :step="1" :step-strictly="true"
              :min="1"></el-input-number>秒之间随机数
          </div>
        </el-form-item>
        <el-form-item label="是否上线" label-width="120px">
          <div style="padding-top: 10px; display: flex; align-items: center">
            <el-switch v-model="formData.valid" active-color="#13ce66" inactive-color="#ff4949" active-text="上线"
              inactive-text="下线" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </el-form-item>
        <div class="upLists">
          <div class="item" v-for="(item, index) in formData.userConfigList" :key="index">
            <el-row style="color: red; margin-left: 10px">所有{{
              dialogInfoType == 0 ? '用户' : '主播'
            }}标签人数加起来不能超过每页推荐人数!</el-row>

            <el-form-item :label="dialogInfoType == 0 ? '用户标签' : '主播标签'" label-width="120px"
              :prop="'userConfigList.' + index + '.userSign'" :rules="rules.userSign">
              <!-- <el-select v-model="item.userSign" placeholder="请选择" clearable filterable style="width: 200px">
                <el-option v-for="(item, index) in dialogInfoType == 0
                  ? userSignlist
                  : hostSignlist" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select> -->
              <el-cascader v-model="item.userSign" clearable :props="propsForItem" :options="currentOptions"
                :key="cascaderKey + '_' + index" change-on-select></el-cascader>
            </el-form-item>
            <el-form-item label="该标签用户人数" label-width="120px" :prop="'userConfigList.' + index + '.userNums'"
              :rules="rules.userNums">
              <el-input-number v-model.trim="item.userNums" :step="1" :step-strictly="true"></el-input-number>
            </el-form-item>
            <el-form-item label="优先级" label-width="120px" :prop="'userConfigList.' + index + '.priorityLevel'"
              :rules="rules.priorityLevel">
              <el-input-number v-model.trim="item.priorityLevel" :step="1" :step-strictly="true"></el-input-number>
            </el-form-item>
            <el-form-item label="状态" label-width="120px">
              <div style="padding-top: 10px; display: flex; align-items: center">
                <el-switch v-model="item.valid" active-color="#13ce66" inactive-color="#ff4949" active-text="上线"
                  inactive-text="下线" :active-value="1" :inactive-value="0">
                </el-switch>
              </div>
            </el-form-item>
            <el-row><el-button style="margin-left: 10px" type="danger"
                @click="formData.userConfigList.splice(index, 1)">删除</el-button></el-row>
          </div>
        </div>
        <el-row><el-button type="primary" @click="listAdd">添加</el-button></el-row>
        <el-row>
          <el-button type="success" @click="handleClose">取消</el-button>
          <el-button type="primary" @click="submitForm('formData')">确认</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { data } from 'jquery'

export default {
  data() {
    return {
      cascaderKey: 0,
      dialogType: 0,
      dialogInfoType: 0,
      // 渠道
      channelList: [],
      search: {
        ruleName: null,
        valid: null,
        listCode: null,
        userSign: null,
        userNums: null,
        channel: null,
      },
      minute: 0,
      formData: {
        channel: null,
        ruleName: null,
        listCode: null,
        userSign: null,
        refreshInterval: null,
        pageSize: null,
        pageMax: null,
        pushTimesMin: null,
        pushTimesMax: null,
        pushLimitSeconds: null,
        pushLimitCount: null,
        hideTimeMinSeconds: null,
        hideTimeMaxSeconds: null,
        valid: 1,
        userConfigList: [
          {
            userSign: null,
            userNums: null,
            priorityLevel: null,
            valid: 1,
          },
        ],
      },
      // 渠道选择相关
      excludeChannel: false,
      selectedChannels: [],
      rules: {
        ruleName: {
          required: true,
          message: '请输入规则名字',
          trigger: 'blur',
        },
        listCode: {
          required: true,
          message: '请选择列表类型',
          trigger: 'change',
        },
        userSign: { required: true, message: '请选择标签', trigger: 'change' },
        refreshInterval: {
          required: true,
          message: '请输入刷新间隔',
          trigger: 'blur',
        },
        pageSize: {
          required: true,
          message: '请输入每页推荐人数',
          trigger: 'blur',
        },
        pageMax: { required: true, message: '请输入最大页数', trigger: 'blur' },
        pushTimesMin: [
          {
            validator: (rule, value, callback) => {
              if (value !== null && value !== undefined && value !== '' && this.formData.pushTimesMax && value > this.formData.pushTimesMax) {
                callback(new Error('推送次数下限不能大于上限'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        pushTimesMax: [
          {
            validator: (rule, value, callback) => {
              if (value !== null && value !== undefined && value !== '' && this.formData.pushTimesMin && value < this.formData.pushTimesMin) {
                callback(new Error('推送次数上限不能小于下限'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        pushLimitSeconds: {
          required: true,
          message: '请输入推送限制时间',
          trigger: 'blur',
        },
        pushLimitCount: {
          required: true,
          message: '请输入推送限制次数',
          trigger: 'blur',
        },
        hideTimeMinSeconds: {
          required: true,
          message: '请输入隐藏时间下限',
          trigger: 'blur',
        },
        hideTimeMaxSeconds: {
          required: true,
          message: '请输入隐藏时间上限',
          trigger: 'blur',
        },
        valid: { required: true, message: '请输入状态', trigger: 'blur' },
        userNums: {
          required: true,
          message: '请输入该标签用户人数',
          trigger: 'blur',
        },
        priorityLevel: {
          required: true,
          message: '请输入优先级',
          trigger: 'blur',
        },
      },
      dialogShow: false,
      // 主播标签名称
      hostSignlist: [],
      // code列表
      codeList: [],
      userSignlist: [],
      tableList: [],
      currentPage: 0,
      totalPages: 0,
      props: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { label, value } = node;
          this.getSignList(value, resolve);
        }
      },
      newProps: [
        { label: '主播', value: 'recommended_list', children: [] },
        { label: '直播', value: 'live_recommended_list', children: [] },
        { label: '语聊', value: 'party_recommended_list', children: [] },
        { label: '行为', value: 'behavior', children: [] },
      ],
      // 编辑时用的完整数据
      editModeProps: [
        { label: '主播', value: 'recommended_list', children: [] },
        { label: '直播', value: 'live_recommended_list', children: [] },
        { label: '语聊', value: 'party_recommended_list', children: [] },
        { label: '行为', value: 'behavior', children: [] },
      ],
      // 是否为编辑模式
      isEditMode: false

    }
  },
  watch: {
    'formData.dialogInfoType': {
      handler(newVal) {

      },
      immediate: true
    }
  },
  created() {
    this.getUserSigns()
    this.getHostSigns()
    this.getList(1)
    this.getChannel()
  },
  computed: {
    commonCascaderProps() {
      return {
        lazy: !this.isEditMode,
        emitPath: false,
        checkStrictly: false,
      }
    },
    propsForFormData() {
      if (this.isEditMode) {
        return {
          emitPath: false,
          checkStrictly: false,
          lazy: false,
          value: 'value',
          label: 'label',
          children: 'children'
        }
      }
      return {
        ...this.commonCascaderProps,
        lazyLoad: (node, resolve) => {
          const { value } = node;
          const type = this.dialogInfoType;
          this.getSignList(value, resolve, type);

        }
      }
    },
    propsForItem() {
      if (this.isEditMode) {
        return {
          emitPath: false,
          checkStrictly: false,
          lazy: false,
          value: 'value',
          label: 'label',
          children: 'children'
        }
      }
      return {
        ...this.commonCascaderProps,
        lazyLoad: (node, resolve) => {
          const { value } = node;
          const type = Math.abs(this.dialogInfoType - 1);
          this.getSignList(value, resolve, type);
        }
      }
    },
    // 动态选择使用的options
    currentOptions() {
      return this.isEditMode ? this.editModeProps : this.newProps;
    }
  },
  methods: {
    loadMoreSignData() {
      console.log('1111');
    },
    // 预加载所有标签数据用于编辑模式
    async preloadAllSignData() {
      const signTypes = ['recommended_list', 'live_recommended_list', 'party_recommended_list', 'behavior'];

      // 重置editModeProps
      this.editModeProps = [
        { label: '主播', value: 'recommended_list', children: [] },
        { label: '直播', value: 'live_recommended_list', children: [] },
        { label: '语聊', value: 'party_recommended_list', children: [] },
        { label: '行为', value: 'behavior', children: [] },
      ];

      for (let i = 0; i < signTypes.length; i++) {
        const signType = signTypes[i];
        // 同时加载主播和用户的数据
        try {
          const hostData = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
            url: this.$store.getters.path.config_userSign_query,
            data: {
              data: {
                signType: signType,
                signTemplate: 'host',
              },
              page: 0,
              pageSize: 50,
            },
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          });

          const userData = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
            url: this.$store.getters.path.config_userSign_query,
            data: {
              data: {
                signType: signType,
                signTemplate: 'user',
              },
              page: 0,
              pageSize: 50,
            },
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          });

          let targetGroup = this.editModeProps.find(item => item.value === signType);
          if (targetGroup) {
            targetGroup.children = [];

            // 添加主播数据
            if (hostData.data.code === 0 && hostData.data.data.list.length > 0) {
              hostData.data.data.list.forEach(item => {
                targetGroup.children.push({
                  value: item.name,
                  label: `${item.name} (主播)`,
                  leaf: true
                });
              });
            }

            // 添加用户数据
            if (userData.data.code === 0 && userData.data.data.list.length > 0) {
              userData.data.data.list.forEach(item => {
                targetGroup.children.push({
                  value: item.name,
                  label: `${item.name} (用户)`,
                  leaf: true
                });
              });
            }
          }
        } catch (error) {
          console.error(`Failed to load signs for ${signType}:`, error);
        }
      }
    },
    // 验证推送次数
    validatePushTimes() {
      if (this.$refs.formData) {
        this.$refs.formData.validateField(['pushTimesMin', 'pushTimesMax'])
      }
    },
    // 处理渠道选择变化
    handleChannelChange() {
      // 格式化渠道字符串
      if (this.selectedChannels.length > 0) {
        const channelStr = this.selectedChannels.join(',')
        this.formData.channel = this.excludeChannel ? `-${channelStr}` : channelStr
      } else {
        this.formData.channel = null
      }
      if (this.excludeChannel) {
        this.getCodeList('all')
      } else {
        this.getCodeList(this.selectedChannels[0])
      }
    },
    // 解析渠道字符串
    parseChannelString(channelStr) {
      if (!channelStr) {
        this.excludeChannel = false
        this.selectedChannels = []
        return
      }

      if (channelStr.startsWith('-')) {
        this.excludeChannel = true
        this.selectedChannels = channelStr.substring(1).split(',').filter(item => item.trim())
      } else {
        this.excludeChannel = false
        this.selectedChannels = channelStr.split(',').filter(item => item.trim())
      }
    },
    async handleEdit(row) {
      // 设置为编辑模式并预加载数据
      this.isEditMode = true
      await this.preloadAllSignData()

      this.formData = JSON.parse(JSON.stringify(row))
      this.minute = row.pushLimitSeconds / 60
      this.dialogInfoType = this.hostSignlist.find(
        (item) => item.name == this.formData.userSign
      )
        ? 0
        : 1

      // 解析渠道字符串
      this.parseChannelString(this.formData.channel)

      this.getCodeList(this.formData.channel)
      this.dialogShow = true
      this.dialogType = 1

      // 强制触发 cascader 重新渲染
      this.$nextTick(() => {
        this.cascaderKey++
      })
    },
    async getSignList(value, resolve, type = 0, page = 0) {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: {
          data: {
            signType: value,
            signTemplate: type == 0 ? 'host' : 'user',
          },
          page: page,
          pageSize: 50,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        resolve([
          {
            value: null,
            label: 'no data',
            leaf: true
          }
        ])
      } else {
        if (res.data.list.length > 0) {
          resolve(res.data.list.map(item => ({
            value: item.name,
            label: item.name,
            leaf: true
          })))
        } else {
          resolve([{
            value: null,
            label: 'no data',
            leaf: true
          }])
        }
      }
    },
    // 格式化跳转页面数据
    formatterJumpData(data) {
      const groupedData = [
        { label: '主播', children: [] },
        { label: '直播', children: [] },
        { label: '语聊', children: [] },
      ]

      // 遍历原始数据，按照 value 大小分类
      data.forEach((item) => {
        if (item.code >= 20001 && item.code <= 30000) {
          // 如果 value 在 20001-30000 之间，属于 语聊 组
          groupedData[2].children.push({ label: item.title + ' | ' + item.code, value: item.code })
        } else if (item.code >= 10001 && item.code <= 20000) {
          // 如果 value 大于 100，属于直播组
          groupedData[1].children.push({ label: item.title + ' | ' + item.code, value: item.code })
        } else if (item.code <= 10000) {
          // 如果 value 小于等于 100，属于主播组
          groupedData[0].children.push({ label: item.title + ' | ' + item.code, value: item.code })
        }
      })
      return groupedData
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [{ label: 'all', value: 'all' }, ...res.data]
      }
    },
    listAdd() {
      const data = {
        userSign: null,
        userNums: null,
        priorityLevel: null,
        valid: 1,
      }
      if (this.dialogType == 1 && this.formData.id) {
        data.ruleId = this.formData.id
      }
      this.formData.userConfigList.push(data)
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    guaranteedHandleCurrentChange(page) {
      this.currentPage = page
      this.getList()
    },
    handleClose() {
      this.dialogShow = false
      this.minute = 0
      this.excludeChannel = false
      this.selectedChannels = []
      this.isEditMode = false // 重置编辑模式状态
      this.formData = {
        ruleName: null,
        listCode: null,
        userSign: null,
        channel: null,
        refreshInterval: null,
        pageSize: null,
        pageMax: null,
        pushTimesMin: null,
        pushTimesMax: null,
        pushLimitSeconds: null,
        pushLimitCount: null,
        hideTimeMinSeconds: null,
        hideTimeMaxSeconds: null,
        valid: 1,
        userConfigList: [
          {
            userSign: null,
          },
        ],
      }
    },
    //获取用户标签列表
    async getUserSigns() {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: {
          data: {
            signType: 'recommended_list',
            signTemplate: 'host',
          },
          page: 0,
          pageSize: 50,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.hostSignlist = res.data.list
      }
    },
    //获取用户标签列表
    async getHostSigns() {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: {
          data: {
            signTemplate: 'user',
            signType: 'recommended_list',
          },
          page: 0,
          pageSize: 50,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.userSignlist = res.data.list
      }
    },
    //获取列表
    async getList(page) {
      if (page) {
        this.currentPage = page
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.recommended_config_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          page: this.currentPage,
        },
        data: {
          ...this.search,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.tableList = res.data.recommendedListRuleConfigDataList
        this.totalPages = res.data.totalPages
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    //获取列表码
    async getCodeList(channel = null) {
      if (!channel) {
        channel = this.formData.channel
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.recommended_config_code,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          channel,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.$set(
          this,
          'codeList',
          res.data?.list?.map((item) => {
            return {
              ...item,
              code: Number(item.code),
            }
          }) || []
        )
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    changeValid(info) {
      const data = JSON.parse(JSON.stringify(info))
      data.valid = Math.abs(data.valid - 1)
      this.update(data, 2)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(this.formData, this.dialogType)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改 0添加 1 修改
    async update(info, type) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          type == 0
            ? this.$store.getters.path.recommended_config_add
            : this.$store.getters.path.recommended_config_post,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success(`${type == 1 ? '添加' : '修改'}成功`)
        this.handleClose()
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 复制
    async copy(id) {
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.recommended_config_copy,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          id,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success('复制成功')
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 删除
    async deletes(id) {
      try {
        await this.$confirm('确定要删除这条规则吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const { data: res } = await this.$axios({
          method: 'post',
          url: this.$store.getters.path.recommended_config_delete,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            id,
          },
        })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg || res.message)
        }
      } catch (error) {
        // 用户取消删除操作
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
  },
  directives: {
    "cascaderScroll": function (el, binding) {
      return
      if (cascaderDom) {
        cascaderDom.addEventListener("scroll", function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            let temp = this.scrollTop;
            binding.value();
            setTimeout(() => {
              this.scrollTop = temp + 100;// 滚动加载更多时，显示的数据在上次位置基础上往上滑动100
            }, 0)
          }
        });
      }
    },
  },
}
</script>

<style scoped lang="scss">
.recommended {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }

  .list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;

    .mode {
      width: 180px;
      padding: 10px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
      flex-direction: column;
      border: 1px solid #ccc;

      i {
        color: #b8abff;
      }
    }
  }

  .con {
    i {
      color: #b8abff;
      text-decoration: underline;
    }
  }
}

.upLists {
  height: max-content;
  width: 100%;

  .item {
    padding: 10px 0;
    border: 1px solid #ccc;
    margin-bottom: 10px;
  }
}
</style>